import { Routes } from '@angular/router';
import { authGuard } from './modules/auth/guards/auth.guard';
import { editContentGuard, skillTreeGuard } from './modules/auth/guards/permission.guard';
import { SideNavBarComponent } from './modules/project-config/side-nav-bar/side-nav-bar.component';

/**
 * Application Routes
 * All routes are protected by authGuard which redirects to SSO if not authenticated
 */
export const routes: Routes = [
  { path: '', redirectTo: '/project-listing', pathMatch: 'full' },

  {
    path: 'project-config',
    loadChildren: () =>
      import('./modules/project-config/project-config.routes').then(
        (m) => m.routes
      ),
    canActivate: [authGuard],
  },
  {
    path: 'project-listing',
    loadChildren: () =>
      import('./modules/project-listing/project-listing.routes').then(
        (m) => m.routes
      ),
    canActivate: [authGuard],
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./modules/home/home.routes').then((m) => m.routes),
    canActivate: [authGuard],
  },
  {
    path: 'content',
    loadChildren: () =>
      import('./modules/content-creation/content-creation.routes').then(
        (m) => m.routes
      ),
    canActivate: [authGuard],
  },
  {
    path: 'review',
    loadChildren: () =>
      import('./modules/review/review.routes').then((m) => m.routes),
    canActivate: [authGuard],
  },
  {
    path: 'edit',
    loadChildren: () =>
      import('./modules/content-updation/content-updation.routes').then(
        (m) => m.routes
      ),
    canActivate: [authGuard, editContentGuard],
  },
  {
    path : 'ips',
    loadChildren: () =>
      import('./modules/ips/ips.routes').then(
        (m) => m.routes
      ),
      canActivate: [authGuard]
  },
  {
    path : 'translation',
    loadChildren: () =>
      import('./modules/translation/translation.routes').then(
        (m) => m.routes
      ),
      canActivate: [authGuard]
  },
  {
    path: 'container',
    loadChildren: () =>
      import('./modules/container-creation/container-main.routes').then(
        (m) => m.routes
      ),
    canActivate: [authGuard]
  },
  {
    path: 'skill-tree',
    loadChildren: () =>
    import('./modules/skill-tree/skill-tree.routes').then((m) => m.routes),
    canActivate: [authGuard, skillTreeGuard]
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./shared/components/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent
      ),
  },

  // Catch-all route redirects to project listing (which will trigger SSO if not authenticated)
  { path: '**', redirectTo: '/project-listing' },
];
